export const enum ExitDeclarationStatusTypeEnum {
    PROCESS = 'process',
    RESERVE = 'reserve',
    DONE = 'done',
    FAIL = 'fail',
}
